/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AgreementStatusEmailFlagsDto } from '../../models/agreement-status-email-flags-dto';

export interface AgreementsControllerUpdateStatusEmailFlags$Params {
  id: number;
      body: AgreementStatusEmailFlagsDto
}

export function agreementsControllerUpdateStatusEmailFlags(http: HttpClient, rootUrl: string, params: AgreementsControllerUpdateStatusEmailFlags$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, agreementsControllerUpdateStatusEmailFlags.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

agreementsControllerUpdateStatusEmailFlags.PATH = '/agreements/{id}/status-email-flags';
